import { api } from "./client";

interface Ticket {
  storage_key: string;
  upload_url: string;
  method: string;
  headers: [string, string][];
  public_url: string;
}

export interface UploadTarget {
  owner_type: "asset" | "product" | "vendor" | "user";
  owner_id?: string;
  collection?: string;
}

/**
 * Presigned upload (03 §storage): ask the API for a ticket, PUT the bytes to
 * storage, then `complete`. Resolves to the public URL.
 */
export async function uploadFile(file: File, target: UploadTarget): Promise<string> {
  const { data: ticket } = await api<Ticket>("/media/uploads", {
    method: "POST",
    body: {
      ...target,
      filename: file.name,
      mime: file.type || "application/octet-stream",
      size_bytes: file.size,
    },
  });
  const res = await fetch(ticket.upload_url, {
    method: ticket.method,
    headers: Object.fromEntries(ticket.headers),
    body: file,
  });
  if (!res.ok) throw new Error(`upload failed (${res.status})`);
  const { data } = await api<{ url: string }>("/media/complete", { method: "POST", body: { storage_key: ticket.storage_key } });
  return data.url;
}
